import {
  Box,
  ClickAwayListener,
  Grid,
  Popper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  IconButton,
  Menu,
  MenuItem,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { TextWithIcon } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import Typography from '@HomaHealth/ui-component-library/lib/_patient-access-components/atoms/Typography';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import React, { useState } from 'react';
import { RECOMMENDED_APPS } from '../../../core-utils/messages/RecommendedAppConstants';
import {
  Button,
  Checklist3,
  Down,
  Exclaimation,
  Folder2,
  NoDocs,
  Processing,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { scrollBarStyles } from '../../../core-utils/messages/CommonConstants';
import { DueDiligenceDataType } from '../../../core-utils/helper-utils/recommendedAppsHelper';
import { NoDataVisual } from '../../../pages/SavingsUtilization';
import { ComparisonDataPros } from '../../../pages/DocumentComparisonPage';
import { compilationDataProps } from '../../../pages/TermCompilerPage';
import { getTextWithToolTip } from '../../../core-utils/helper-utils/riskPatientDetailsHelper';
import MoreVertIcon from '@mui/icons-material/MoreVert';

export const ContractChipList = ({
  selectedItems,
}: {
  selectedItems: string[];
}) => {
  const useStyles = makeStyles()({
    btn: {
      backgroundColor: patientAccessTheme.palette.grey[100],
      border: `1px solid ${patientAccessTheme.palette.grey[300]}`,
      borderRadius: '0.25rem',
    },
    count: {
      background: '#F7FAFF',
      borderRadius: '4px',
      border: '0.5px solid #727E9C',
      padding: '1px 5px',
      height: '22px',
      verticalAlign: 'middle',
      marginLeft: '0.5rem',
    },
    popup: {
      width: '300px',
      borderRadius: '4px',
      border: '1px solid' + patientAccessTheme.palette.grey[300],
      background: patientAccessTheme.palette.background.default,
      boxShadow: '0px 2px 4px 0px #0000000D',
      marginTop: '4px',
      zIndex: 500,
    },
    chips: {
      display: 'flex',
      flexWrap: 'wrap',
      alignContent: 'flex-start',
      gap: '10px',
      padding: '12px',
      height: 'auto',
      maxHeight: '270px',
      overflowY: 'auto',
      width: '100%',
      ...scrollBarStyles,
    },
    buttons: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      padding: '16px',
      justifyContent: 'flex-start',
    },
  });
  const { classes } = useStyles();
  const [anchorElement, setAnchorElement] = useState<null | HTMLElement>(null);

  const handleClickButton = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElement(anchorElement ? null : event.currentTarget);
  };
  const open = Boolean(anchorElement);
  const id = open ? 'simple-popper' : undefined;
  return (
    <>
      <Button
        variant="outlined"
        styleProps={{
          width: '100%',
        }}
        label={
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              width: '100%',
              overflow: 'hidden',
            }}
          >
            <Tooltip
              disableFocusListener
              placement="top-end"
              title={
                <Typography fontSize="12px">{selectedItems[0]}</Typography>
              }
              arrow
            >
              <Box
                style={{
                  backgroundColor: '#F7FAFF',
                }}
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  borderRadius: '4px',
                  border: '0.5px solid #727E9C',
                  padding: '1px 5px',
                  height: '22px',
                  alignItems: 'center',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  maxWidth: '100%',
                  fontSize: '12px',
                  fontWeight: 500,
                  color: patientAccessTheme.palette.text.mediumemphasis,
                }}
              >
                <Typography
                  component="span"
                  styleProps={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    fontSize: '12px',
                    fontWeight: 500,
                    color: patientAccessTheme.palette.text.mediumemphasis,
                    display: 'block', // important to allow ellipsis
                  }}
                >
                  {selectedItems[0]}
                </Typography>
                {/* {selectedItems[0]} */}
              </Box>
            </Tooltip>

            {selectedItems.length > 2 && (
              <Typography
                textColor={patientAccessTheme.palette.text.mediumemphasis}
                fontType="semiBold"
                fontSize="12px"
                className={classes.count}
              >
                +{selectedItems.length - 1}
              </Typography>
            )}
          </Box>
        }
        endIcon={<Down />}
        width="100%"
        height="36px"
        onClick={handleClickButton}
        className={classes.btn}
      />
      <Popper
        id={id}
        open={open}
        anchorEl={anchorElement}
        placement="bottom-start"
        className={classes.popup}
      >
        <ClickAwayListener onClickAway={() => setAnchorElement(null)}>
          <Grid className={classes.chips}>
            {selectedItems?.map((item: string) => (
              <Typography
                textColor={patientAccessTheme.palette.text.mediumemphasis}
                fontType="medium"
                fontSize="13px"
                styleProps={{
                  background: '#F7FAFF',
                  borderRadius: '4px',
                  border: '0.5px solid #727E9C',
                  padding: '1px 5px',
                  height: '22px',
                  verticalAlign: 'middle',
                }}
              >
                {getTextWithToolTip(item, 20)}
              </Typography>
            ))}
          </Grid>
        </ClickAwayListener>
      </Popper>
    </>
  );
};

export type Column = {
  name: string;
  width?: string;
};

type ComparisonTableProps = {
  columns: Column[];
  rowsData: any[];
  showMenu?: boolean;
  menuOptions?: string[];
   
  onMenuSelect?: (row: any, option: string) => void;
  handleRowClick: (
     
    eg_nid: DueDiligenceDataType['eg_nid'],
     
    status: DueDiligenceDataType['status'] | compilationDataProps['status'],
     
    contract_ids: ComparisonDataPros['contract_ids'],
     
    company_name: ComparisonDataPros['comparison_name'],
     
    vendor_type: ComparisonDataPros['vendor_type'],
     
    comparison_id: ComparisonDataPros['_id'] | compilationDataProps['_id'],
  ) => void;
   
  onRegenerate?: (row: ComparisonDataPros) => void;
};

const useStyles = makeStyles()({
  table: {
    border: '1px solid ' + patientAccessTheme.palette.grey[300],
    borderRadius: '0.25rem',
    overflow: 'hidden',
    marginBottom: '1rem',
  },
  headerRow: {
    backgroundColor: patientAccessTheme.palette.grey[400],
    '& th:last-child': {
      borderRight: 'none',
    },
  },
  cell: {
    padding: '20px 20px 16px 20px',
    borderBottom: '1px solid ' + patientAccessTheme.palette.grey[300],
    verticalAlign: 'middle',
  },

  ready: {
    backgroundColor: patientAccessTheme.palette.status.white,
  },
  inProgress: {
    backgroundColor: '#E8EBF7',
  },
  noDocs: {
    backgroundColor: '#F8E3E4',
  },
  processing: {
    backgroundColor: '#FFF7EB',
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    cursor: 'pointer',
  },
  statusCell: {
    textAlign: 'center',
  },
  statusComp: {
    display: 'flex',
    justifyContent: 'center',
  },
});

const ComparisonTable: React.FC<ComparisonTableProps> = ({
  columns,
  rowsData,
  showMenu = false,
  menuOptions,
  onMenuSelect,
  handleRowClick,
  onRegenerate,
}) => {
  const messages = RECOMMENDED_APPS.MA_DUE_DILIGENCE.COMPARISON_TABLE;
  const { classes } = useStyles();

  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);
  const [selectedRow, setSelectedRow] = useState<any>(null);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>, row: any) => {
    setMenuAnchor(event.currentTarget);
    setSelectedRow(row);
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
    setSelectedRow(null);
  };

  const handleMenuOption = (option: string) => {
    if (onMenuSelect && selectedRow) {
      onMenuSelect(selectedRow, option);
    }
    handleMenuClose();
  };

  const getBackground = (
    status: DueDiligenceDataType['status'] | compilationDataProps['status'],
  ) => {
    switch (status) {
      case 'Ready':
        return classes.ready;
      case 'In Progress':
      case 'Terms Not Selected':
        return classes.inProgress;
      case 'No Documents Uploaded':
      case 'Failed Compilation':
        return classes.noDocs;
      case 'Processing':
        return classes.processing;
      default:
        return classes.ready;
    }
  };

  const getStatusComponent = (
    status: DueDiligenceDataType['status'] | compilationDataProps['status'],
    row?: any,
  ) => {
    switch (status) {
      case 'In Progress':
        return (
          <TextWithIcon
            label={
              <Typography
                fontSize="16px"
                lineHeight="22.4px"
                fontType="medium"
                textColor={'#96A3D9'}
              >
                {messages.IN_PROGRESS}
              </Typography>
            }
            endIcon={<Checklist3 />}
            endIconLeftMargin="8px"
          />
        );
      case 'Terms Not Selected':
        return (
          <TextWithIcon
            label={
              <Typography
                fontSize="16px"
                lineHeight="22.4px"
                fontType="medium"
                textColor={'#96A3D9'}
              >
                {messages.NO_TERMS}
              </Typography>
            }
            endIcon={<Exclaimation stroke="#8293D9" />}
            endIconLeftMargin="8px"
          />
        );
      case 'No Documents Uploaded':
        return (
          <TextWithIcon
            label={
              <Typography
                fontSize="16px"
                lineHeight="22.4px"
                fontType="medium"
                textColor={'#E08083'}
              >
                {messages.NO_DOCS}
              </Typography>
            }
            endIcon={<NoDocs />}
            endIconLeftMargin="8px"
          />
        );
      case 'Failed Compilation':
        return (
          <TextWithIcon
            label={
              onRegenerate ? (
                <Typography
                  fontSize="16px"
                  lineHeight="22.4px"
                  fontType="medium"
                  textColor="#E08083"
                  styleProps={{
                    textDecoration: 'underline dotted',
                    textUnderlineOffset: '4px',
                    cursor: 'pointer',
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    onRegenerate?.(row);
                  }}
                >
                  {messages.FAILED_COMPILATION + ' Regenerate'}
                </Typography>
              ) : (
                <Typography
                  fontSize="16px"
                  lineHeight="22.4px"
                  fontType="medium"
                  textColor="#E08083"
                  styleProps={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    gap: '5px',
                  }}
                >
                  {messages.FAILED_COMPILATION}
                </Typography>
              )
            }
            endIcon={<Exclaimation />}
            endIconLeftMargin="8px"
          />
        );
      case 'Processing':
        return (
          <TextWithIcon
            label={
              <Typography
                fontSize="16px"
                lineHeight="22.4px"
                fontType="medium"
                textColor={'#ED9B74'}
              >
                {messages.PROCESSING}
              </Typography>
            }
            endIcon={<Processing />}
            endIconLeftMargin="8px"
          />
        );
      default:
        return <></>;
    }
  };

  const renderRow = (row: any) => {
    return (
      <TableRow className={getBackground(row?.status)}>
        <TableCell className={classes.cell}>
          <Box className={classes.flex}>
            {showMenu && (
              <IconButton size="small" onClick={(e) => handleMenuOpen(e, row)}>
                <MoreVertIcon fontSize="small" />
              </IconButton>
            )}
            <Box
              className={classes.flex}
              onClick={() =>
                handleRowClick(
                  row?.eg_nid,
                  row?.status,
                  row?.contract_ids,
                  row?.company_name,
                  row?.vendor_type,
                  row?._id,
                )
              }
            >
              <Folder2 height="20px" width="20px" />
              <Typography
                fontSize="14px"
                fontType="medium"
                textColor={patientAccessTheme.palette.primary.main}
                styleProps={{
                  textDecoration: 'underline dashed',
                  textUnderlineOffset: '0.25rem',
                }}
              >
                {row?.company_name}
              </Typography>
            </Box>
          </Box>
        </TableCell>
        {row?.status === 'Ready' ? (
          <>
            {row?.otherData.map((item: any) => (
              <TableCell className={classes.cell}>{item}</TableCell>
            ))}
          </>
        ) : (
          <TableCell
            colSpan={columns.length - 1}
            className={classes.statusCell}
          >
            <div className={classes.statusComp}>
              {getStatusComponent(row?.status, row)}
            </div>
          </TableCell>
        )}
      </TableRow>
    );
  };

  return (
    <Grid className={classes.table}>
      {rowsData.length > 0 ? (
        <Table>
          <TableHead>
            <TableRow className={classes.headerRow}>
              {columns.map((item, idx) => (
                <TableCell
                  key={idx}
                  className={classes.cell}
                  style={{ width: item.width }}
                >
                  <Typography
                    fontSize="12px"
                    fontType="medium"
                    lineHeight="12px"
                    textColor={patientAccessTheme.palette.text.highemphasis}
                  >
                    {item.name}
                  </Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>{rowsData?.map((row) => renderRow(row))}</TableBody>
        </Table>
      ) : (
        <NoDataVisual text="No groups found. Start a new project to begin your analysis." />
      )}

      {/* Menu for actions */}
      <Menu
        anchorEl={menuAnchor}
        keepMounted
        open={Boolean(menuAnchor)}
        onClose={handleMenuClose}
      >
        {menuOptions &&
          menuOptions.map((option, idx) => (
            <MenuItem key={idx} onClick={() => handleMenuOption(option)}>
              {option}
            </MenuItem>
          ))}
      </Menu>
    </Grid>
  );
};

export default ComparisonTable;
